<template>
  <div class="main-content columns is-centered">
    <div class="column is-11">
      <div class="section">
        <div class="columns has-text-centered">
          <div class="column">
            <h2 class="title is-2">
              Financial Disclosure
            </h2>
            <div class="subtitle is-2">
              Statements Search
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-vcentered has-less-padding">
          <div class="column is-4">
            <textbox
              v-model="searchString"
              placeholder="Search by first, and/or last name"
              name="search"
              type="text"
              class="cell no-margin"
            />
          </div>
          <div class="column is-4">
            <dropdown
              v-model="selectedOfficialsCat"
              :options="officialsCategories"
              value-key="label"
              text-key="label"
              default-option="Officials Categories"
              placeholder="Officials Categories"
            />
          </div>
          <div class="column is-4">
            <dropdown
              v-model="selectedYear"
              :options="years"
              value-key="value"
              text-key="value"
              default-option="Year"
              placeholder="Year"
            />
          </div>
          <div class="column is-4">
            <v-selectmenu
              v-model="selectedStatements"
              key-field="id"
              show-field="description"
              :data="requiredStatements"
              :language="'en'"
              :multiple="true"
              :full-width="true"
              :query="false"
              :title="'Select Statements'"
            >
              <button
                id="statements-dropdown-btn"
                type="button"
                class="sm-default-btn"
              >
                <div>
                  <strong>Statements</strong> {{ selectedStatements }}
                </div>
              </button>
            </v-selectmenu>
          </div>
          <div class="column is-3">
            <button
              id="search-btn"
              class="button is-secondary"
              type="submit"
              @click="filterUsers"
            >
              <span>Search</span>
              <span class="icon"><i class="fas fa-search" /></span>
            </button>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="cell">
              <div
                id="filers-table"
                class="table-responsive"
              >
                <v-server-table
                  ref="results"
                  :columns="tableColumns"
                  :options="tableOptions"
                  @loaded="loaded"
                >
                  <template
                    slot="primaryPosition"
                    slot-scope="props"
                  >
                    <template v-if="props.row.primaryAgencyId">
                      {{ getControlValueDesc(props.row.primaryAgencyId, 'agencies') }}
                    </template>
                  </template>
                  <template
                    slot="statements"
                    slot-scope="props"
                  >
                    <div v-html="getStatementLink(props.row.formTypes)" />
                  </template>
                </v-server-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import EditUserProfile from '@/modals/EditUserProfile';
import UserStatements from '@/modals/UserStatements';
import { Textbox, Dropdown } from '@phila/phila-ui';
import UploadStatements from '@/modals/UploadStatements';
import { ServerTable } from 'vue-tables-2';
import vSelectMenu from 'v-selectmenu';

Vue.use(ServerTable, {}, false, 'bulma');
Vue.use(vSelectMenu);

export default {
  components: {
    Dropdown,
    Textbox,
  },
  data() {
    return {
      agencies: [],
      selectedYear: '',
      officialsCategories: [
        {
          label: 'Elected Officials',
        },
        {
          label: 'Senior Administration Officials',
        },
        {
          label: 'Board & Commission Members',
        },
      ],
      selectedAgencies: '',
      requiredStatements: [
        {
          id: 'city',
          description: 'City',
        },
        {
          id: 'state',
          description: 'State',
        },
        {
          id: 'mayor',
          description: 'Mayor',
        },
      ],
      includeInactive: false,
      selectedOfficialsCat: '',
      selectedStatements: '',
      selectedUserAccess: 'filer',
      searchString: '',
      filteredUsers: [],
      allUsers: [],
      filter: {
        cityForm: false,
        mayorForm: false,
        stateForm: false,
        isSysAdmin: false,
        isDeptHead: false,
        isFiler: true,
      },
      tableColumns: [
        "firstName",
        "lastName",
        "position",
        "year",
        "officialsCategory",
        "statements",
      ],
      tableOptions: {
        requestFunction: this.customRequestFunction,
        responseAdapter: this.customResponseAdapter,
        headings: {
          firstName: "First Name",
          lastName: "Last Name",
          formTypes: "Statements",
          officialsCategory: "Official's Category",
          requiredStatements: function() {
            return <div>
                Required Statements
              <div class="columns">
                <div class="column">
                    State
                </div>
                <div class="column">
                    City
                </div>
                <div class="column">
                    Mayor
                </div>
              </div>
            </div>;
          },
          editFiler: "Edit",
        },
        columnsClasses: {
          id: 'text-center',
          requiredStatements: "has-text-centered",
        },
        sortIcon: {
          is: "fal fa-sort",
          up: "fad fa-sort-up",
          down: "fad fa-sort-down",
        },
        perPage: 20,
        perPageValues: [],
        sortable: [ "lastName", "firstName" ],
        filterable: false,
        pagination: {
          edge: true,
          nav: 'scroll',
        },
      },
    };
  },
  computed: {
    years () {
      return this.$store.getters[ 'admin/activeControlValues' ]('PUBLICSEARCHYEARS');
    },
  },
  async created () {
    await this.initialFetch();
    await this.initialAssign();
  },
  methods: {
    async customRequestFunction (params) {
      const query = {
        ascending: params.ascending === 1 ? true : false,
        searchString: this.searchString,
        pageNumber: params.page,
        pageSize: params.limit,
        orderByCol: params.orderBy ? params.orderBy.charAt(0).toUpperCase() + params.orderBy.slice(1) : params.orderBy,
      };

      if (this.selectedAgencies !== '') {
        query.departmentIds = this.selectedAgencies.split(',').map(Number);
      }

      if (this.selectedStatements !== '') {
        query.statementTypes = this.selectedStatements.split(',');
      }

      if (this.selectedOfficialsCat !== '') {
        query.officialsCategory = this.selectedOfficialsCat;
      }

      if (this.selectedYear !== '') {
        query.years = [ parseInt(this.selectedYear) ];
      }

      try {
        return await this.$store.dispatch('filings/fetchPublicFilings', query);
      } catch (err) {
        return [];
      }
    },
    customResponseAdapter (data) {
      const resp = { data: [], count: 0 };
      if (data) {
        resp.data = data.publicSearch;
        resp.count = data.totalCount;
      }
      return resp;
    },
    loaded() {
    },
    async initialAssign () {},
    async initialFetch () {
      let promises = [];
      promises.push(this.$store.dispatch('admin/getControlValue', 'agency'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'PUBLICSEARCHYEARS'));
      return Promise.all(promises);
    },
    filterUsers () {
      this.$refs['results'].refresh();
    },
    searchFilter (users) {
      return users.filter(user => {
        let firstName = user.firstName ? user.firstName.toLowerCase() : '';
        let lastName = user.lastName ? user.lastName.toLowerCase() : '';
        let searchString = this.searchString.toLowerCase();
        return firstName === searchString || lastName === searchString || `${firstName} ${lastName}` === searchString || (`${firstName}${lastName}`.search(searchString) !== -1);
      });
    },
    statementsFilter (users) {
      return users.filter(user => {
        return user[this.selectedStatement] === 'Y';
      });
    },
    departmentsFilter (users) {
      return users.filter(user => {
        return parseInt(user.primaryAgencyId) === parseInt(this.selectedAgency);
      });
    },
    editFiler(row) {
      this.$store.commit('user/setTempId', row.id);
      this.$modal.show(EditUserProfile, {}, {
        classes: [ 'is-large' ],
      });
    },
    viewUserStatements(row) {
      this.$store.commit('user/setTempId', row.id);
      this.$modal.show(UserStatements, {}, {
        classes: [ 'is-large' ],
      });
    },
    uploadStatements (row) {
      this.$modal.show(UploadStatements, {
        filer: row,
      },
      {
        classes: [ 'is-small' ],
      });
    },
    getStatementLink (statements) {
      let statementsStrs = [];
      statements.forEach(stmnt => {
        statementsStrs.push(`<a href="${stmnt.latestStatement.signedUrl}" target="_blank">${stmnt.formType}</a>`);
      });
      return statementsStrs.join(" | ");
    },
  },
};
</script>
<style lang="scss">
  .v-dropdown-caller {
    width: 100%;
    .sm-caller-container {
      width: 100%;
      button.sm-default-btn {
        width: 100%;
        max-width: 100%;
        text-align: left;
        border-radius: 0;
        box-shadow: none;
        height: 40px;
        padding: 0 0 0 10px;
        vertical-align: middle;
        > div {
          max-width: 90%;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 40px;
          &:before {
            content: " ";
            background: white;
            width: 30px;
            height: 100%;
            display: block;
            z-index: 9;
            top: 0;
            right: 0;
            position: absolute;
          }
          &:after {
            content: "";
            right: 1.125em;
            z-index: 10;
            border: 3px solid transparent;
            border-color: #0f4d8f;
            border-radius: 2px;
            border-right: 0;
            border-top: 0;
            display: block;
            height: 0.625em;
            margin-top: -0.4375em;
            pointer-events: none;
            position: absolute;
            top: 50%;
            transform-origin: center;
            width: 0.625em;
            transform: rotate(-45deg);
          }
        }
      }
    }
  }
  .table-checkboxes {
    .cell {
      line-height: 0;
    }
    .far, .fas, .fal {
      font-size: 20px;
      color: #0e4d90;
    }
    .disabled {
      .far, .fas, .fal {
        color: #a9a9a9;
      }
    }
  }
  .columns.has-less-padding {
    .column {
      padding: .4rem 0.75em ;
    }
  }
  .VueTables {
    td, th {
      vertical-align: middle;
      position: relative;
      overflow-wrap: break-word;
    }
    td:first-child {
      width: 10%;
      padding-left: 10px;
    }
    .legend-icons {
      position: absolute;
      top:2px;
      right:2px;
      width: auto;
      height: auto;
      text-align: right;
      line-height: 0;
      span {
        padding: 0;
        margin: 0;
      }
    }
  }
  .legends {
    margin-bottom: 2px;
  }
</style>